/**
 * Adzuki.Form
 *
 * @author Patrick Verrier <pverrier@cruiseplanners.com>
 */

(function Form($, Adzuki)
{
	"use strict";

	var form = {
		componentForms: {},
		submitting    : false,

		// SET-8: set by a host that renders forms inside something it needs to keep alive -
		// the My Settings modal is the case it exists for. See the default branch of the
		// submit success handler. Null means the framework's own redirect stands.
		onSuccessRedirect: null,

		// SET-12: NOTIFICATION ONLY - it changes nothing about how an error is handled. The
		// settings modal needs to know a submit failed so its status indicator can say so;
		// every existing branch keeps its exact behaviour whether this is set or not.
		onSubmitError: null,

		// SET-58, decision S23: claims a confirmation_prompt response by returning false, the
		// way onSuccessRedirect claims a redirect. Anything else - including no return value -
		// leaves the per-form confirmation() path exactly as it was.
		onConfirmationPrompt: null,
	};

	var _submit,
	    _errorHandler,
	    _cleanUp,
	    _initForm;

	// init all forms currently on the page
	$(document).ready(function documentReady() {

		const form       = $('form[data-form-component]');
		const formName   = form.attr('name');
		const storageKey = Adzuki.agent_id + '-' + formName +'Form';

		_initForm(form);

		if (localStorage.getItem(storageKey) !== null) {
			restoreFormData(form, storageKey);
		}

		// any input group textbox with a "clear" button should have its input cleared
		$(document).on('click', '.input-group button[role="clear"]', function clearTextInput() {
			var $input = $(this).prev('input');

			if ($input.val()) {
				$input.val('').trigger('cleared');
			}
		});

		// toggle password visibility when an element with .password-toggle clicked
		$(document).on('click', '.password-toggle', function togglePasswordVisibility(e) {
			var $btn   = $(this),
			    $icon  = $btn.find('.fas'),
			    $input = $btn.prev('input[type="password"], input[type="text"]'),
			    current_type,
			    len;

			e.preventDefault();

			// try several reasonable places to find the related input
			if (!$input.length) {
				$input = $btn.closest('.input-group').find('input[type="password"], input[type="text"]').first();
			}
			if (!$input.length) {
				$input = $btn.siblings('input[type="password"], input[type="text"]').first();
			}
			if (!$input.length) {
				// nothing we can toggle
				return;
			}

			current_type = $input.attr('type');

			if (current_type === 'password') {
				$input.attr('type', 'text');
				$icon.removeClass('fa-eye').addClass('fa-eye-slash');
			} else {
				$input.attr('type', 'password');
				$icon.removeClass('fa-eye-slash').addClass('fa-eye');
			}

			// restore focus and move caret to end
			$input.focus();
			len = $input.val().length;
			try {
				$input[0].setSelectionRange(len, len);
			} catch (ignore) {
				// ignore (older browsers)
			}
		});
	});

	/**
	 * Initializes a component form loaded via AJAX to be processed by this system.
	 *
	 * @param  string form_name Form name of component form to be initialized.
	 */
	form.initAjaxForm = function initAjaxForm(form_name)
	{
		var $form = $('form[name="' + form_name + '"]'),
		    form_obj;

		if (_initForm($form)) {
			// if form has been registered, run .load()
			if (form_name in form.componentForms) {
				form_obj         = form.componentForms[form_name];
				form_obj.element = $form[0];

				if (typeof form_obj.load === 'function') {
					form_obj.load($form);
				}
			}
		}
	};

	/**
	 * initializes a form regardless of origin (static/ajax).
	 * this inits:
	 * 	form submit handlers
	 * 	textarea auto resizing
	 * 	recipient selection
	 * 	destination selection
	 * 	multiselects
	 * 	phone number auto formatting
	 * 	"check all" checkboxes
	 * 	image cropers
	 * 	integer-only fields
	 * 	airline typeaheads
	 * 	airport typeaheads
	 * 	date/time pickers
	 * 	force uppercase input
	 */
	_initForm = function _initForm($forms)
	{
		var _textareaResize;

		// SET-125: MEASURED FROM NOTHING, NOT FROM THE CURRENT HEIGHT.
		//
		// scrollHeight can never report less than clientHeight, so once an inline height had been
		// set this could only ever grow: type five lines and delete four, and the textarea kept
		// the height the five lines had earned. Clearing the height first makes scrollHeight
		// describe the CONTENT rather than the box that content used to need, and the css floor
		// (textarea.autoheight is min-height 38px) is what stops it collapsing past one row.
		//
		// SHARED, AND THAT IS DELIBERATE. Every textarea[data-autoresize] in the app runs through
		// here - the two credit-card manage forms and three Home Office destination-theme fields
		// besides this one - and all of them have the same one-way behaviour today. Growing is
		// unchanged; only the shrink is new.
		var __textareaResize = function __textareaResize($el) {
			var offset;

			$el.css('height', 'auto');

			offset = $el[0].offsetHeight - $el[0].clientHeight;
			$el.css('height', $el[0].scrollHeight + offset);
		};

		if (!$forms.length) {
			return false;
		}

		// setup form submit handlers
		$forms.on('submit', _submit);


		// textarea autoresizing
		_textareaResize = Adzuki.Debounce(__textareaResize, 150);

		$.each($forms.find('textarea[data-autoresize]'), function __initTextareaAutoResize() {
			var $self  = $(this);

			$self.on('keyup', function __textareaKeyup() {
				_textareaResize($self);
			});

			__textareaResize($self);
		});

		// recipient selection
		$.each($forms.find('div.recipient-selection'), function __initRecipientSelection() {
			Adzuki.RecipientSelection($(this));
		});

		// destination selection
		$.each($forms.find('div.destination-selection'), function __initDestinationSelection() {
			Adzuki.DestinationSelection($(this));
		});

		// multi-selects
		$.each($forms.find('select[multiple]'), function __initMultiSelect() {
			var $self              = $(this);
			var include_select_all = false;
			var live_search        = false;

			if ($self.data('traditional')) {
				return;
			}

			if ($self.data('include-select-all')) {
				include_select_all = true;
			}

			if ($self.data('live-search')) {
				live_search = true;
			}

			// SET-162: INSIDE THE MY SETTINGS MODAL AN ENHANCED SELECT ALWAYS DROPS DOWN.
			//
			// dropupAuto measures against the WINDOW, which is the wrong box here: the panel body
			// scrolls (overflow: auto), so there is always room below because the panel makes some -
			// while a menu that opens UPWARD is clipped by the panel's top edge and cannot be
			// scrolled to, since scrolling moves the control with it. QA found it on Specialties,
			// whose Brand and Interest/Style pickers are the lower row of a 2x2 grid and so sit low
			// enough to flip; the search box at the top of the menu was the part that disappeared.
			//
			// SAME FINDING AS SET-141, which forced the datetimepicker down for the same reason, and
			// SCOPED THE SAME WAY - outside the overlay the window IS the box, so every other screen
			// in every app keeps the library's own choice.
			$self.selectpicker({
				dropupAuto        : $self.closest('.my-settings-overlay').length === 0,
				actionsBox        : include_select_all,
				selectedTextFormat: 'count',
				size              : 10,
				liveSearch        : live_search,
				virtualScroll     : false,
			});

			// fired by custom valHooks, see Adzuki\_global.js
			$self.on('changed.bs.select', function refreshSelectVal(e, argv) {
				if (argv && typeof argv === 'object' && argv.programmatic) {
					$(this).selectpicker('refresh');
				}
			});
		});


		// phone number fields
		$.each($forms.find('input.phone-number'), function __initPhoneNumberInput() {
			var $self = $(this);

			$self.on('blur', function __formatPhoneNumber() {
				// first, remove any non alpha numeric chars in case they've entered parens, for example.
				// then format the string like the hard-core php phone validation
				var formatted  = $self.val().replace(/\W/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');

				if ($self.val().replace(/[^0-9]/g, "").length === 10) {
					$self.val(formatted);
				}
			});
		});

		// format international phone number fields. example: +1 555-123-4567
		$.each($forms.find('input.international-phone-number'), function __initInternationalPhoneNumberInput() {
			var $self = $(this);

			$self.on('blur', function __formatInternationalPhoneNumber() {
				var input               = $self.val();
				var formatted           = '';
				var country, area, prefix, line, digits;
				var plusIndex, afterPlus, countryCodeEnd, i;
				var existingCountryCode, remainingDigits;

				// Check if input already contains a "+" (country code)
				if (input.indexOf('+') >= 0) {
					// Extract the country code part (everything up to and including the +)
					plusIndex = input.indexOf('+');
					afterPlus = input.substring(plusIndex + 1);

					// Find where the country code ends (first non-digit after +)
					countryCodeEnd = 0;
					for (i = 0; i < afterPlus.length; i++) {
						if (!(/\d/).test(afterPlus[i])) {
							break;
						}
						countryCodeEnd = i + 1;
					}

					// Extract country code and remaining digits
					existingCountryCode = afterPlus.substring(0, countryCodeEnd);
					remainingDigits     = afterPlus.substring(countryCodeEnd).replace((/\D/g), '');

					// Only format if we have enough digits after the country code
					if (remainingDigits.length >= 10) {
						area      = remainingDigits.slice(0, 3);
						prefix    = remainingDigits.slice(3, 6);
						line      = remainingDigits.slice(6, 10);
						formatted = '+' + existingCountryCode + ' ' + area + '-' + prefix + '-' + line;
					} else {
						formatted = input; // Keep original if incomplete
					}
				} else {
					// No country code, extract digits and format
					digits = input.replace((/\D/g), '');

					// Only format if we have digits
					if (digits.length > 0) {
						// If exactly 10 digits, assume +1 country code
						if (digits.length === 10) {
							country   = '1';
							area      = digits.slice(0, 3);
							prefix    = digits.slice(3, 6);
							line      = digits.slice(6, 10);
							formatted = '+' + country + ' ' + area + '-' + prefix + '-' + line;
						}
						// If more than 10 digits, extract country code
						else if (digits.length > 10) {
							country   = digits.slice(0, digits.length - 10);
							area      = digits.slice(-10, -7);
							prefix    = digits.slice(-7, -4);
							line      = digits.slice(-4);
							formatted = '+' + country + ' ' + area + '-' + prefix + '-' + line;
						}
						// If less than 10 digits, don't format (incomplete number)
						else {
							formatted = input; // Keep original input
						}
					}
				}

				$self.val(formatted);
			});
		});


		// "check all" checkboxes
		$.each($forms.find('input[type="checkbox"].check-all'), function __initCheckAll() {
			var $self = $(this);

			$self.on('change', function _toggleCheckAll() {
				var checked = $self.prop('checked');
				if (checked) {
					$self.parents('form').find('input[type="checkbox"]:not(.check-all,.check-all-ignore):not(:disabled):not(:checked)').prop('checked', checked).trigger('change');
				} else {
					$self.parents('form').find('input[type="checkbox"]:not(.check-all,.check-all-ignore):not(:disabled):checked').prop('checked', checked).trigger('change');
				}
				$('body').trigger('check-all-done', [checked]);
			});
		});

		// image croppers
		$.each($forms.find('input[data-form-component-image]'), function __initImageCropper() {
			Adzuki.ImageCropper($(this));
		});

		// force integer input
		$.each($forms.find('input.force-integer'), function __initIntInput() {
			var $self = $(this);

			// only allow integer chars to be typed in
			$self.keypress(function keyp(event) {
				var charCode = event.charCode;
				if ( (charCode < 48) || (charCode > 57) ) {
					return false;
				}
			});

			// if user attempts to paste a string with non-ints, strip out the non-int characters
			$self.on("paste", function paste(event) {
				var $in = $(this);

				setTimeout(function delay() {
					var current_val = $in.val(),
					    forced_val  = current_val.replace(/\D/g, '');
					    $in.val(forced_val);
				}, 1);
			});
		});

		// force uppercase input
		$.each($forms.find('input.force-uppercase'), function __initUppercaseInput() {
			var $self = $(this);

			$self.keyup(function onKeyup(event) {
				var val = String($self.val());
				$self.val(val.toUpperCase());
			});
		});

		// airline typeaheads
		$.each($forms.find('input.airline'), function __initAirlineTypeahead() {
			Adzuki.Typeahead(
				$(this),
				'/Airlines/search',
				function __selected_airline(airline, $self, typeahead) {
					if (airline.id) {
						typeahead.setHiddenValue(airline.id);
					} else {
						$self.val('');
					}
				}
			);
		});

		// airport typeaheads
		$.each($forms.find('input.airport-typeahead'), function __initAirportTypeahead() {
			Adzuki.Typeahead(
				$(this),
				'/Airports/search',
				function __selected_airport(airport, $self, typeahead) {
					if (airport.id) {
						typeahead.setHiddenValue(airport.id);
					} else {
						$self.val('');
					}
				}
			);
		});

		// group typeaheads
		$.each($forms.find('input.group-typeahead'), function __initGroupTypeahead() {
			var include_ho   = $(this).data('include-ho'),
			    include_opps = $(this).data('include-opps'),
			    url          = '/Groups/searchGroups/' + include_ho + '/' + include_opps + '/';

			Adzuki.Typeahead(
				$(this),
				url,
				function __selected_group(group, $self, typeahead) {
					var $hidden_source = $('#' + $self.data('hidden-source'));

					if (group.id) {
						typeahead.setHiddenValue(group.id);

						if ($hidden_source.length > 0) {
							$hidden_source.val(group.group_source);
						}

					} else {
						$self.val('');

						if ($hidden_source.length > 0) {
							$hidden_source.val('');
						}
					}
				}
			);
		});

		// reservation typeaheads
		$.each($forms.find('input.reservation-typeahead'), function __initReservationTypeahead() {
			Adzuki.Typeahead(
				$(this),
				'/Reservations/searchReservations',
				function __selected_reservation(reservation, $self, typeahead) {
					if (reservation.id) {
						typeahead.setHiddenValue(reservation.id);
					} else {
						$self.val('');
					}
				}
			);
		});

		// currency inputs should be positive float values with a precision of 2
		$.each($forms.find('input.price-field'), function __initIntInput() {
			var $self = $(this);

			$self.data('fc-old-value', $self.val());

			if ($self.hasClass('zero-default')) {
				if ($self.val() === '') {
					$self.val('0.00');
				}

				$self.on('focus', function __blankZero() {
					var $input = $(this);

					if (parseFloat($input.val()) === 0 && !$input.prop('readonly')) {
						$input.val('');
					}
				});
			}

			$self.on('change keyup paste', function __forceCurrency() {
				var $input          = $(this),
					new_value       = $input.val(),
					old_value       = $input.data('fc-old-value'),
					formatted_value;

				if (new_value !== old_value) {
					if (new_value === '') {
						$input.data('fc-old-value', '');

						if (old_value !== '') {
							$input.trigger('pricechanged');
						}

						return;
					}

					if (new_value.match(/[^\d\.]/g) !== null) {
						$input.val(old_value);

						return;
					}

					if (new_value.match(/\./g) !== null && new_value.match(/\./g).length > 1) {
						$input.val(old_value);

						return;
					}

					if (isNaN(parseFloat(new_value))) {
						$input.val(old_value);

						return;
					}

					formatted_value = accounting.formatNumber(new_value, 2, '');

					if ((parseFloat(new_value) - parseFloat(formatted_value)) !== 0) {
						$input.val(formatted_value);

						new_value = formatted_value;
					}

					if (new_value !== old_value) {
						$input.data('fc-old-value', new_value);

						$input.trigger('pricechanged');
					}
				}
			});

			$self.on('blur', function __formatCurrency() {
				var $input = $(this),
				    value  = $input.val();

				if (!$input.prop('readonly')) {
					if (value !== '') {
						$input.val(accounting.formatNumber(value, 2, ''));
					} else if ($input.hasClass('zero-default')) {
						$input.val('0.00');
					}
				}
			});
		});

		// date and time pickers
		$.each($forms.find('input[type="date"]'), function initDatePicker(i, el) {
			Adzuki.DateTimePicker(el);
		});

		$.each($forms.find('input[type="time"]'), function initTimePicker(i, el) {
			Adzuki.DateTimePicker(el, 'hh:mm a', 'HH:mm:ss');
		});

		$.each($forms.find('input[data-daterange]'), function initDateRange(i, el)
		{
			var $el               = $(el),
			    $check_in_hidden  = $el.siblings('[id$="' + ($el.data('date1-name') || 'check_in') + '"]'),
			    $check_out_hidden = $el.siblings('[id$="' + ($el.data('date2-name') || 'check_out') + '"]');

			(function _initDateRange($check_in, $check_out) {
				var opts = {
					// autoApply: true,
				};

				if ($el.data('position')) {
					opts.opens = $el.data('position');
				}

				if ($el.data('direction')) {
					opts.drops = $el.data('direction');
				}

				if ($el.data('max-date')) {
					opts.maxDate = $el.data('max-date');
				}

				if ($el.data('min-date')) {
					opts.minDate = $el.data('min-date');
				}

				if ($el.data('max-span')) {
					opts.maxSpan = {
						days: $el.data('max-span')
					};
				}

				if ($el.data('start-date')) {
					opts.startDate = $el.data('start-date');
				}

				if ($el.data('end-date')) {
					opts.endDate = $el.data('end-date');
				}

				if ($el.data('clear')) {
					opts.locale = { cancelLabel: 'Clear' };
				}

				if ($el.data('start-empty')) {
					opts.autoUpdateInput = false;
				}

				if ($el.data('show-dropdowns')) {
					opts.showDropdowns = true;
				}

				if ($el.data('max-year')) {
					opts.maxYear = $el.data('max-year');
				}

				if ($el.data('min-year')) {
					opts.minYear = $el.data('min-year');
				}

				$el.daterangepicker(opts);

				if ($el.data('clear')) {
					$el.on('cancel.daterangepicker', function _dateRangeClearInput(ev, picker) {
						$(this).val('');
					});
				}

				// if you want the input to start blank, autoUpdateInput disables
				// filling the field in entirely, for some stupid reason.
				// so this restores that functionality.
				if ($el.data('start-empty')) {
					$el.on('apply.daterangepicker', function _dateRangePopulateInput(ev, picker) {
						$(this).val(picker.startDate.format('MM/DD/YYYY') + ' - ' + picker.endDate.format('MM/DD/YYYY'));
					});
				}

				if ($check_in.length && $check_out.length) {
					$el.on('hide.daterangepicker', function _dateRangeUpdateInputs(ev, picker) {
						$check_in.val(picker.startDate.format('YYYY-MM-DD'));
						$check_out.val(picker.endDate.format('YYYY-MM-DD'));
					});
				}
			}($check_in_hidden, $check_out_hidden));
		});

		// html (tinyMCE) editors
		$.each($forms.find('.html-editor'), function __initEditor() {
			var $self   = $(this),
			    options = {};

			// options for the editor may be set in data attributes. they need to be named like data-editor-options-height="400", as an example.
			// this code will use those options with init the editor
			$.each($self.data(), function addOptions(key, val) {
				var option_key;

				if (key.indexOf('editorOptions') === 0) {
					option_key = key.replace("editorOptions", "").toLowerCase();

					options[option_key] = val;
				}
			});

			Adzuki.Editor('#' + $self.attr('id'), options);
		});

		return true;
	};

	/**
	 * Method bound to all forms which intercepts submission and handles it via AJAX instead.
	 *
	 * @param  object e Event object.
	 */
	_submit = function _submit(e)
	{
		var self           = this,
		    $self          = $(this),
		    $file_inputs   = $self.find('input[type="file"]'),
		    attribute_data = {},
		    this_form      = form.componentForms[self.name],
		    $file_input,
		    data;

		e.preventDefault();

		// fix safari 11.x bug that breaks everything if there's an empty file input
		if ($file_inputs) {
			$.each($file_inputs, function safari11BugFix(i, input) {
				$file_input = $(input);

				if (!$.trim($file_input.val())) {
					$file_input.data('name', $file_input.attr('name'));
					$file_input.removeAttr('name');
				} else if ($file_input.data('name')) {
					$file_input.attr('name', $file_input.data('name'));
				}
			});
		}

		// SET-21: THE LAST CHANCE TO WRITE A FIELD BEFORE THE PAYLOAD IS TAKEN.
		//
		// `new FormData(this)` below reads the inputs as they stand, so anything a form has to
		// COMPUTE into a field must be written before this line - and a component form cannot do
		// that from a `submit` handler of its own. _initForm() binds _submit FIRST and then calls
		// the component's load(), so a handler bound there is always SECOND, and jQuery fires
		// handlers in binding order. The payload is already taken by the time it runs.
		//
		// THAT IS NOT HYPOTHETICAL. My CP Email builds its rendered signature into a hidden field,
		// did it from a submit handler, and every save stored the stale copy the panel had been
		// rendered with. The title beside it updated normally and the preview looked right -
		// because the preview is built live from the settings, not from what was stored - so
		// nothing on screen disagreed with itself. QA found it in the database.
		//
		// OPTIONAL, AND ONLY FOR A FORM THAT DECLARES IT, so no existing form changes behaviour.
		if (this_form !== undefined && typeof this_form.beforeSubmit === 'function') {
			this_form.beforeSubmit($self);
		}

		data = new FormData(this);

		if (form.submitting) {
			return;
		}

		if (this_form !== undefined)
		{
			if (this_form.confirm_before_submit && !this_form.confirmed)
			{
				Adzuki.CustomConfirm({
					body   : (this_form.confirm_message) ? this_form.confirm_message : null,
					confirm: function confirmed() {
						this_form.confirmed = true;
						$self.submit();
					}
				});

				return false;
			}
		}

		form.submitting = true;

		$self.find('.has-error').removeClass('has-error').trigger('errorClassRemoved');

		$self.find('button[type="submit"]').addClass('disabled');

		$self.find('.form-loader').css('visibility', 'visible');

		$self.find(':input').each(function inputIterator(i, input)
		{
			var $input           = $(input),
			    input_attributes = {},
			    name,
			    last_key;

			$.each(input.attributes, function attributeIterator(j, attribute)
			{
				if (attribute.name !== 'value') {
					input_attributes[attribute.name] = attribute.value;
				}
			});

			if ($input.data('name')) {
				input_attributes['name'] = $input.data('name');
			}

			if ('name' in input_attributes) {
				name = input_attributes['name'];

				// eslint-disable-next-line no-magic-numbers
				if (name.substr(0, 20) === 'form_component_data[') {
					// eslint-disable-next-line no-magic-numbers
					name = input_attributes['name'].slice(10, -1).replace(/\]\[/g, '.');

					last_key = name.match(/.([^.]*)$/)[1];

					if (last_key === '' || parseInt(last_key).toString() === last_key) {
						name = name.replace(/.[^.]*$/, '');
					}

					name = name.replace(/^[^.]*./, '');
				}

				if (!(name in attribute_data)) {
					if (!('type' in input_attributes)) {
						input_attributes['type'] = $(input).prop('tagName').toLowerCase();
					}

					attribute_data[name] = input_attributes;
				}
			}
		});

		data.append('form_component_attribute_data', JSON.stringify(attribute_data));

		$.ajax({
			url        : $self.attr('action'),
			type       : 'POST',
			data       : data,
			processData: false,
			contentType: false,
			success    : function successHandler(response)
			{
				var error_message   = '';

				if (this_form !== undefined) {
					this_form.confirmed = false;
				}

				if (typeof response === 'string') {
					_errorHandler(self, 'parsererror', response);

					return;
				}

				if (self.name in form.componentForms && typeof form.componentForms[self.name].success === 'function') {
					if (!form.componentForms[self.name].success(response)) {
						_cleanUp(self);
					}
				} else {
					switch (response['status']) {
						case 'validation_error':
							error_message = Adzuki.Form.handleValidationErrors(response['data']);
							if ('custom_error' in response) {
								error_message = response['custom_error'];
							}
							Adzuki.Form.throwSubmissionError(error_message);

							if (typeof form.onSubmitError === 'function') {
								form.onSubmitError(self, response['status'], response);
							}

							_cleanUp(self);
							break;

						case 'confirmation_prompt':
							// SET-58, decision S23: a host that wants to answer the prompt itself claims it by
							// returning false, exactly as onSuccessRedirect does. The settings modal uses this so
							// ONE dialog serves any form's confirm() - ground rule 6 puts confirmations inside the
							// modal, and a per-form confirmation() handler would have to be written again for every
							// form that grows a confirm(). With no hook registered the per-form path below is
							// untouched.
							if (typeof form.onConfirmationPrompt === 'function' && form.onConfirmationPrompt(self, response) === false) {
								_cleanUp(self);
								break;
							}

							if (self.name in form.componentForms && typeof form.componentForms[self.name].confirmation === 'function') {
								form.componentForms[self.name].confirmation(response);
							} else {
								console.log('A status of "confirmation_prompt" is being returned by the form. The intent when "confirmation_prompt" is returned is for a confirmation() method to be defined in the form\'s custom JS file and for the user to be given an option to confirm or decline the prompt. The received response is below.');
								console.log(response);
							}

							_cleanUp(self);
							break;

						case 'processing_error':
							error_message = Adzuki.Form.buildProcessingError(response['data']);
							Adzuki.Form.throwSubmissionError(error_message);

							if (typeof form.onSubmitError === 'function') {
								form.onSubmitError(self, response['status'], response);
							}

							_cleanUp(self);
							break;
						default:
							// SET-8: a host that must survive the save gets to answer the redirect
							// first. The My Settings modal registers this so a successful save
							// re-renders its panel rather than navigating the whole CP|central page
							// away and taking the modal, and the advisor's place in it, with it.
							//
							// Only this branch is touched. The three error statuses above keep their
							// exact behaviour, and with nothing registered - which is every other
							// form in the app - so does this one.
							if (typeof form.onSuccessRedirect === 'function' && form.onSuccessRedirect(self, response) === false) {
								_cleanUp(self);

								break;
							}

							window.location.href = response['data'];
							break;
					}
				}
			},
			error: function errorHandler(jq_xhr, error)
			{
				if (this_form !== undefined) {
					this_form.confirmed = false;
				}

				if (typeof form.onSubmitError === 'function') {
					form.onSubmitError(self, 'transport_error', jq_xhr);
				}

				_errorHandler(self, error, jq_xhr.responseText);
			},
		});
	};

	/**
	 * Handles unknown form errors.
	 *
	 * @param  object form_element Form element of the form that the unknown error occurred for.
	 */
	_errorHandler = function _errorHandler(form_element, error, response)
	{
		if (Adzuki.dev && error === 'parsererror') {
			Adzuki.StatusMessage(
				'warning',
				'A non-JSON string was received from the server, displaying below for debugging purposes:<br><br><div class="form-debugger">' + response + '</div>',
				'Warning',
				{
					bg_dismiss  : true,
					column_class: 'col-md-8 col-md-offset-2',
				}
			);
		} else if (form_element.name in form.componentForms && typeof form.componentForms[form_element.name].error === 'function') {
			form.componentForms[form_element.name].error(error, response);
		} else {
			Adzuki.StatusMessage('Error', 'An unknown error has occurred. Please try submitting the form again in a few minutes.');
		}

		_cleanUp(form_element);
	};

	/**
	 * Cleans up after a form has been submitted but does not trigger a redirect.
	 *
	 * @param  object form_element Form element of the form to clean up.
	 */
	_cleanUp = function _cleanUp(form_element)
	{
		$(form_element).find('.form-loader').css('visibility', 'hidden');

		$(form_element).find('button[type="submit"]').removeClass('disabled');

		form.submitting = false;
	};

	/**
	 * Registers a component form to be processed by this system.
	 *
	 * @param  object form_obj Form object of component form to be registered.
	 */
	form.registerForm = function registerForm(form_obj)
	{
		var $form_jqo = $('form[name="' + form_obj.name + '"]');

		// eslint-disable-next-line no-magic-numbers
		if ($form_jqo.length > 0) {
			form_obj.element = $form_jqo[0];

			if (typeof form_obj.load === 'function') {
				form_obj.load($form_jqo);
			}
		}

		form.componentForms[form_obj.name] = form_obj;
	};

	form.forceFloat = function forceFloat($jElement)
	{
		var max_decimals = 2,
		    stripped     = $jElement.val().replace(/[^\d\.\-]/g, ''),   // strip out any commas for example
		    entered      = parseFloat(stripped),
		    forced_value = entered.toFixed(max_decimals);

		if (isNaN(forced_value)) {
			forced_value = 0;
			forced_value = forced_value.toFixed(max_decimals);
		}

		$jElement.val(forced_value);
	};

	/**
	 * Builds the HTML for validation errors.  By default will also add a class to the fields that failed validation.
	 *
	 * @param  object  response_data     validation errors
	 * @param  boolean highlight_fields  only set to false if you don't want the fields that failed validation to be highlighted. Maybe you want to do something custom instead?  Otherwise don't pass in this param
	 */
	form.handleValidationErrors = function handleValidationErrors(response_data, highlight_fields)
	{
		var error_message = '',
		    add_class     = true,
		    input_jqo,
		    _focus;

		if (typeof highlight_fields === "boolean") {
			add_class = highlight_fields;
		}

		error_message    += '<ul>';

		// eslint-disable-next-line guard-for-in, no-inner-declarations, vars-on-top
		for (var i in response_data) {
			// eslint-disable-next-line guard-for-in, no-inner-declarations, vars-on-top
			for (var j in response_data[i]['errors']) {
				error_message += '<li>' + response_data[i]['errors'][j] + '</li>';
			}

			// support highlighting multiple fields per error
			if (response_data[i][0] === undefined) {
				if (response_data[i]['attributes']) {
					if (response_data[i]['attributes']['id']) {
						input_jqo = $('#' + response_data[i]['attributes']['id']);
					}
					else {
						input_jqo = $('input[name="' + response_data[i]['attributes']['name'] + '"]');
					}

					if (add_class === true) {
						markErrorFields(input_jqo);
					}

					if (i === '0') {
						if (input_jqo.is(":visible")) {
							input_jqo.focus();
						} else {
							_focus = input_jqo.parents('.form-group').find('input:visible');

							if (_focus[0]) {
								_focus[0].focus();
							}
						}
					}
				}
			}
			else
			{
				// eslint-disable-next-line guard-for-in, no-inner-declarations, vars-on-top
				for (var y in response_data[i])
				{
					if (y === 'errors') {
						continue;
					}

					if (response_data[i][y]['attributes']) {
						if (response_data[i][y]['attributes']['id']) {
							input_jqo = $('#' + response_data[i][y]['attributes']['id']);
						}
						else {
							input_jqo = $('input[name="' + response_data[i][y]['attributes']['name'] + '"]');
						}

						if (add_class === true) {
							markErrorFields(input_jqo);
						}
					}
				}
			}

		}

		error_message += '</ul>';

		return error_message;
	};

	/**
	 * Builds the HTML for a form processing error
	 *
	 * @param string response_data form processing error message
	 */
	form.buildProcessingError = function buildProcessingError(response_data)
	{
		var error_message = '<ul><li>' + response_data + '</li></ul>';
		return error_message;
	};

	/**
	 * When there is a validation or processing error, use this function to throw an alert to the user.
	 *
	 * @param string custom_error_message whatever additional message you intend to provide below the basic message.
	 */
	form.throwSubmissionError = function throwSubmissionError(custom_error_message)
	{
		var error_message = 'The form could not be submitted for the following reason(s):<br><br>';
		error_message    += custom_error_message;

		Adzuki.StatusMessage('Error', error_message);
	};

	/**
	 * Checks if there is a validation error or processing error and throws error message if there is
	 * @param  object  response  response from an attempted form submission
	 * @return boolean           true if there is an error, false if it's all good
	 */
	form.hasError = function hasError(response)
	{
		var error_message = '';

		if ( (response !== null) && ((response.status === 'validation_error') || (response.status === 'processing_error')) ) {

			if (response.status === 'validation_error') {
				error_message = Adzuki.Form.handleValidationErrors(response['data']);
			} else {
				error_message = Adzuki.Form.buildProcessingError(response['data']);
			}

			if ('custom_error' in response) {
				error_message = response['custom_error'];
			}

			Adzuki.Form.throwSubmissionError(error_message);

			return true;
		}

		return false;
	};

	/**
	 * Clears all fields in a form
	 * Removes validation errors
	 * TODO: Add more fields
	 * @param form_obj
	 */
	form.resetForm = function resetForm(form_obj)
	{
		var $form_jqo = $('form[name="' + form_obj.name + '"]');
		
		// eslint-disable-next-line no-magic-numbers
		if ($form_jqo.length > 0) {
			$form_jqo.find('.has-error').removeClass('has-error');
			$form_jqo.find('input').val('');
			$form_jqo.find('textarea').val('');
		}
	};

	/**
	 * By default will also add a class of "has-error" to the fields' form-group that failed validation.
	 * @param  {jQuery obj} $input the field that failed validation
	 */
	function markErrorFields($input)
	{
		var $parent = $input.parents('.form-group'),
		    $el;

		if ($parent.length > 0) {
			$el = $parent;
		} else {
			$el = $input.parent();
		}

		$el.addClass('has-error').trigger('errorClassAdded');
	}


	/**
	 * Load and then remove Form data from localStorage if coming back from an attachment redirect.
	 */
	function restoreFormData($form, storageKey)
	{
		const savedData = localStorage.getItem(storageKey);

		if (savedData) {
			try {
				const formData = JSON.parse(savedData);
				/* console.log(savedData, 'savedData');*/
				if ($form && $form.length > 0) {
					$.each(formData, function getFormData(key, value) {
						let $elements = $form.find(`[name="${key}"]`);

						$elements.each(function setFormInputs() {
							const $field = $(this);

							if ($field.is('input[type="checkbox"]') || $field.is('input[type="radio"]')) {
								if ($field.val() === value) {
									$field.prop('checked', true);
									if (value === '1' || value === 'yes') {
										setTimeout(function triggerChange() {
											$field.trigger('change'); // Fire change event after everything is initialized
										}, 0);
									}
								}
							} else if ($field.is('select[multiple]')) {
								$field.val(value).trigger('change');

							} else if ($field.is('input[type="date"]')) {
								const validDate = new Date(value).toISOString().split('T')[0];
								$field.val(validDate).trigger('change');
							} else if ($field.is('input[type="hidden"]')) {
								if ($field.prev().hasClass('adzuki-datetimepicker')) {
									const dateTimePicker = $field.siblings('.adzuki-datetimepicker');
									const validDate      = new Date(value).toISOString().split('T')[0];

									$field.val(validDate);

									if (dateTimePicker.data('DateTimePicker')) {
										dateTimePicker.attr('data-value', validDate);
										dateTimePicker.data('DateTimePicker').date(validDate);
									}

								} else {
									$field.val(value);
								}

							} else {
								$field.val(value);
							}

							// Trigger change for other event listeners
							$field.trigger('change');
						});

					});

					// localStorage.removeItem(storageKey);
				}
			} catch (error) {
				console.error('Error restoring form data:', error);
				// Optional: Remove corrupted data
				// localStorage.removeItem(storageKey);
			}
		}
	}

	Adzuki.Form = form;
}(jQuery, window.Adzuki || {}));
